// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'
import { refreshHeader } from '../@core/auth/jwt/jwtService'
import { getHeaders } from '../auth/utils'
import { store } from './store'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser(),
    socket:{},
    view:false
  },
  reducers: {
    handleLogin: (state, action) => {

      state.userData = action.payload
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
      localStorage.setItem('userData', JSON.stringify(action.payload))
      
      localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
      refreshHeader()
      
      // localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))
    },
    handleLogout: state => {

      // if(store)
      // store.dispatch({type:'REFRESH_MANAGE_STORE'})
      
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem('navigation')
      localStorage.removeItem('navLinks')
      localStorage.clear();
      
      state.socket = {}
    },
    handleSocket: (state,action) => {
      state.socket = action.payload
    },
    viewPasswordModal: (state, action) =>{
      state.view = action.payload
    }
  }
})

export const { handleLogin, handleLogout,handleSocket, viewPasswordModal } = authSlice.actions

export default authSlice.reducer
//hjhdkjhksjhkjdhksjhkdjhskjhdkjh